/**
 * Creates placeholder texture.
 * @param {string} fillStyle Placeholder texture color.
 * @param {Function} callback Callback on load.
 */
const createImage = (function () {
    const canvas = document.createElement("canvas");
    const context2d = canvas.getContext("2d");
    canvas.width = canvas.height = 1;

    return function (fillStyle, callback = null) {
        context2d.fillStyle = fillStyle;
        context2d.fillRect(0, 0, 1, 1);

        const image = document.createElement("img");

        image.isReadyPromise = new Promise((resolve => {
            image.onload = function () {
                if (callback) callback(image);
                resolve(image);
            };
        }));

        image.src = canvas.toDataURL("image/png");

        return image;
    }
})();

export default createImage;
export { createImage };